import TabelaPeriodos from './tabelaperiodos';
import { DataAmigavel, TempoAmigavelAteHoje } from '@/shared/utils/datas';
import { EnumerateDefensores } from '@/modules/people/defensor.service';
import { Fragment, useEffect, useState } from 'react';
import { IconeDoTipoPeriodo } from '@/modules/business/periodo/Icones';
import { Links } from '@/shared/constants/navegacao';
import { ReadDefensorResponseDto } from '@/api.types';
import { TipoPeriodoDescanso } from '../enums/tipo-periodo-descanso.enum';
import { toast } from 'react-toastify';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import { useParams } from 'react-router-dom';

export default function PeriodoIndexPage() {
  const { setActions } = useBreadcrumbActions();
  const params = useParams();
  const id = params.id ? Number(params.id) : 0;

  const [defensorId, setDefensorId] = useState<ReadDefensorResponseDto>();
  const [defensores, setDefensores] = useState<ReadDefensorResponseDto[] | null>();

  useEffect(() => {
    EnumerateDefensores(0, 1000)
      .then((result) => {
        setDefensores(result.objects);
        if (
          result !== undefined &&
          result !== null &&
          result.objects.length > 0
        ) {
          setDefensorId(
            id > 0 ? result.objects.find((a) => a.id == id) : result.objects[0],
          );
        }
      })
      .catch((res) => {
        toast.error((res as string) + '');
      });
  }, []);

  useEffect(() => {
    const href = defensorId ? Links.Acoes_Criar + '/' + defensorId.id : Links.Acoes_Index;
    setActions({ primary: { label: 'Cadastrar', href, onClick: () => { } } });
    return () => setActions({});
  }, [setActions, defensorId]);

  const handleChangeDefensor = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    setDefensorId(
      defensores!.find(
        (p) => p.id == (event.target.value as unknown as number),
      ),
    );
  };

  function GetAccordionItem(
    nome: string,
    titulo: string,
    tipo: TipoPeriodoDescanso,
  ) {
    const accordionId = `heading${nome}`;
    const accordionDiv = `collapse${nome}`;

    return (
      <Fragment>
        <h2 className="accordion-header" id={accordionId}>
          <button
            className="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target={`#${accordionDiv}`}
            aria-expanded="false"
            aria-controls={accordionDiv}
          >
            {IconeDoTipoPeriodo(tipo)}
            <span className="ms-2">{titulo}</span>
          </button>
        </h2>
        <div
          id={accordionDiv}
          className="accordion-collapse collapse"
          aria-labelledby={accordionId}
        >
          <div className="accordion-body">
            <TabelaPeriodos defensor={defensorId!} tipo={tipo} />
          </div>
        </div>
      </Fragment>
    );
  }

  return (
    <>
      <div className="row">
        <div className="col-12">
          <h3 className="pt-4">Ações para Defensor</h3>
          <span className="blockquote-footer pb-4 text-end">
            Tabela de benefícios registrados para os defensores.
          </span>
        </div>
        <hr className="pb-4" />

        {/* Filtros */}
        <div className="col-auto">
          <label htmlFor="defensor" className="col-form-label">
            Defensor(a):
          </label>
        </div>
        <div className="col-auto">
          <select
            title="Defensor"
            className="form-select"
            id="defensor"
            name="defensor"
            onChange={handleChangeDefensor}
            value={defensorId?.id}
          >
            {defensores !== undefined &&
              defensores !== null &&
              defensores.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.pessoa?.nome}
                </option>
              ))}
          </select>
        </div>
        <div className="col-12 text-end">
          <span className="blockquote-footer">
            Admissão: {DataAmigavel(defensorId?.data_admissao)} (
            {TempoAmigavelAteHoje(defensorId?.data_admissao as unknown as Date)}) / Idade:{' '}
            {DataAmigavel(defensorId?.pessoa?.dataNascimento)} (
            {TempoAmigavelAteHoje(defensorId?.pessoa?.dataNascimento as unknown as Date)}).
          </span>
        </div>

        {/* Tabelas / Listas */}
        <div className="">
          <div className="accordion" id="accordionExample">
            <div className="accordion-item">
              {GetAccordionItem('ferias', 'Férias', TipoPeriodoDescanso.Ferias)}
            </div>
            <div className="accordion-item">
              {GetAccordionItem(
                'folganatalicia',
                'Folga Natalícia',
                TipoPeriodoDescanso.FolgaNatalicia,
              )}
            </div>
            <div className="accordion-item">
              {GetAccordionItem(
                'abonotrabalhado',
                'Abono por Dia Trabalhado',
                TipoPeriodoDescanso.AbonoTrabalhado,
              )}
            </div>
            <div className="accordion-item">
              {GetAccordionItem(
                'abonoespecial',
                'Abono Especial',
                TipoPeriodoDescanso.AbonoEspecial,
              )}
            </div>
            <div className="accordion-item">
              {GetAccordionItem(
                'licencapremio',
                'Licença Prêmio',
                TipoPeriodoDescanso.LicencaPremio,
              )}
            </div>
            <div className="accordion-item">
              {GetAccordionItem(
                'licencaoutrosmotivos',
                'Licença Outros Motivos',
                TipoPeriodoDescanso.LicencaOutros,
              )}
            </div>
            {/* <div className="accordion-item">
							{GetAccordionItem("afastamentos", "Afastamentos", TipoPeriodoDescanso.Afastamento)}
						</div> */}
          </div>
        </div>
        <div className="col-12">
          <br />
          <br />
        </div>
      </div>
    </>
  );
}
